// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 10 10\"> <path stroke=\"#F8D57E\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.5 9.5H3c-.5525 0-1-.447-1-.9995V6c0-.5-.75-1-.75-1S2 4.5 2 4V1.5a1 1 0 0 1 1-1h.5m3 9H7c.5525 0 1-.447 1-.9995V6c0-.5.75-1 .75-1S8 4.5 8 4V1.5a1 1 0 0 0-1-1h-.5\"/> </svg>";
// Exports
module.exports = code;